import { unmountModalApp } from '../../modal/unmountModalApp';

export default {
  props: {
    appId: {
      type: String,
      required: true,
    },
  },
  methods: {
    removeAppFromDom() {
      // eslint-disable-next-line fp/no-this
      unmountModalApp(this.appId);
    },
  },
};
